module.exports = __webpack_public_path__ + "img/underReview.ad1a032c.png";